import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import CheckboxButton from 'components/Luxkit/Checkbox/CheckboxButton'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Clickable from 'components/Common/Clickable'

const TextBlock = styled.div`
  margin-left: ${rem(8)};
`

const StyledCloseProximityContainer = styled(Clickable)`
  display: flex;
  width: 100%;
  background-color: #FFF;
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  padding: ${rem(20)};
  margin-top: ${rem(8)};
`

interface Props {
  checked: boolean;
  onToggleConnectRooms: () => void;
  className?: string;
}

function RequestConnectingRoomsInput(props: Props) {
  const { checked, onToggleConnectRooms, className } = props

  return (
    <StyledCloseProximityContainer onClick={onToggleConnectRooms} className={className}>
      <CheckboxButton size="large" checked={checked} />
      <TextBlock>
        <BodyText variant="medium" weight="bold">I would like to request connecting rooms</BodyText>
        <BodyText variant="medium">Note: Connecting rooms are dependant on hotel availability and will be confirmed at time of check-in.</BodyText>
      </TextBlock>
    </StyledCloseProximityContainer>
  )
}

export default RequestConnectingRoomsInput
